exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Row___3IwJ6 {  \n  display: flex;  \n  flex-direction: row;  \n  align-items: center;  \n} \n\n.Column___w9Fle { \n  display: flex;  \n  flex-direction: column; \n  align-items: center;  \n} \n\n.Title___1PTyg {  \n  font-size: var(--font-size-sans-large); \n  margin-bottom: 0.5rem;  \n} \n\n.ReleaseNotesLink___2_Y38 { \n  color: var(--color-button-active);  \n}", ""]);

// exports
exports.locals = {
	"Row": "Row___3IwJ6",
	"Column": "Column___w9Fle",
	"Title": "Title___1PTyg",
	"ReleaseNotesLink": "ReleaseNotesLink___2_Y38"
};